import {
  Component, Vue,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import GraphQLIntrospectionModule from '@/store/graphql-introspection';
import PimcoreEntityIntrospection from '@/classes/graphql-introspection/PimcoreEntityIntrospection';

/**
 * Introspection helpers without @ProvideReactive — safe for nested components
 * (e.g. RatesPage + EntityFilter) that only load listings and must not re-define
 * the same injection key on the component tree.
 */
@Component
export default class PimcoreIntrospectionCoreMixin extends Vue {
  graphQLIntrospectionModule = getModule(GraphQLIntrospectionModule, this.$store);

  pimcoreEntityIntrospection: PimcoreEntityIntrospection | null = null;

  async getPimcoreIntrospection(entityName: string) {
    return this.graphQLIntrospectionModule.getPimcoreIntrospection(entityName);
  }

  async initPimcoreIntrospection(entityName: string) {
    this.pimcoreEntityIntrospection = await this.getPimcoreIntrospection(entityName);
  }
}
